import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {Button, Form, Input, message} from 'antd';
import './index.less';
import {toPng} from '../../../utils/helper/helper';
import {useCallback, useEffect, useState} from 'react'
import Api from '../../../utils/apis/Api';

export default function Login() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [captcha, setCaptcha] = useState({loading: true, enabled: false, uuid: '', img: '', error: ''});

    const loadCaptcha = useCallback(async () => {
        setCaptcha(current => ({...current, loading: true, error: ''}));
        try {
            const response = await Api.getCode();
            const data = response.data || {};
            const enabled = data.captchaEnabled === true && Boolean(data.uuid && data.img);
            setCaptcha({
                loading: false,
                enabled,
                uuid: enabled ? data.uuid : '',
                img: enabled ? data.img : '',
                error: ''
            });
        } catch (error) {
            setCaptcha({loading: false, enabled: false, uuid: '', img: '', error: error.message || '验证码加载失败'});
        }
    }, []);

    useEffect(() => {
        loadCaptcha();
    }, [loadCaptcha]);

    const handleSubmit = async values => {
        setLoading(true);
        try {
            await Api.login({
                username: values.username,
                password: values.password,
                code: captcha.enabled ? values.code : undefined,
                uuid: captcha.enabled ? captcha.uuid : undefined
            });
            window.location.href = `${process.env.PUBLIC_URL}/main/home`;
        } catch (error) {
            message.error(error.message || '登录失败');
            if (captcha.enabled) {
                form.setFieldsValue({code: ''});
                loadCaptcha();
            }
        } finally {
            setLoading(false);
        }
    };

    return <div className='wh100 layout-v center j-center login-paper'>
        <div className='layout-v center j-center login-panel' style={{
            backgroundImage: 'url(' + toPng('loginbg') + ')'
        }}>
            <div className='login-title'>用户登录</div>
            <Form size='large' className='login-form' form={form} onFinish={handleSubmit}>
                <Form.Item className='border-item' name="username" rules={[{
                    required: true,
                    message: "请输入用户名"
                }]}>
                    <Input size="large" autoComplete='username' addonBefore={<UserOutlined style={{color: '#58F2D8'}}/>}
                           placeholder="请输入你的用户名"/>
                </Form.Item>
                <Form.Item className='border-item' name="password" rules={[{
                    required: true,
                    message: "请输入密码"
                }]}>
                    <Input.Password size="large" autoComplete='current-password'
                                    addonBefore={<LockOutlined style={{color: '#58F2D8'}}/>}
                                    placeholder="请输入你的密码"/>
                </Form.Item>
                {captcha.enabled && <Form.Item className='captcha-item' name="code" rules={[{
                    required: true,
                    message: "请输入验证码"
                }]}>
                    <div className='captcha-row'>
                        <Input size="large" placeholder="请输入验证码"/>
                        <img src={'data:image/gif;base64,' + captcha.img} alt="验证码" onClick={loadCaptcha}/>
                    </div>
                </Form.Item>}
                {captcha.error && <div className='captcha-error' onClick={loadCaptcha}>{captcha.error}，点击重试</div>}
                <Form.Item>
                    <Button className='login-btn' size="large" loading={loading} type="primary" htmlType="submit"
                            disabled={captcha.loading || Boolean(captcha.error)}>登录</Button>
                </Form.Item>
            </Form>

        </div>

        <footer className='login-footer'>
            <span>Copyright © 四川数据集团有限公司</span>
            <span className='login-footer-divider'/>
            <span>建议使用 Chrome、Firefox 浏览器</span>
            <span className='login-footer-divider'/>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">蜀ICP备2022030011号-5</a>
        </footer>
    </div>

}
